import React, { useState } from "react";
import { SeoAnalysisReport } from "../seoAnalyzer";
import { Download, Share2, RefreshCw, Check } from "lucide-react";

interface ReportActionsProps {
  report: SeoAnalysisReport;
  onRescan: () => void;
}

export const ReportActions: React.FC<ReportActionsProps> = ({ report, onRescan }) => {
  const [copied, setCopied] = useState(false);

  const downloadJson = () => {
    const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(report, null, 2));
    const downloadAnchor = document.createElement("a");
    downloadAnchor.setAttribute("href", dataStr);
    downloadAnchor.setAttribute("download", `cyber_seo_${report.domain}_${Date.now()}.json`);
    document.body.appendChild(downloadAnchor);
    downloadAnchor.click();
    downloadAnchor.remove();
  };

  const copySummaryText = () => {
    const summary = `🚀 CYBER SEO INTEL REPORT: ${report.domain}\nOverall Score: ${report.scores.overall}/100\nSEO: ${report.scores.seo} | Perf: ${report.scores.performance} | Acc: ${report.scores.accessibility} | Sec: ${report.scores.security}\nAudited by CyberSEO Scanner.`;
    navigator.clipboard.writeText(summary);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap", justifyContent: "flex-end", marginBottom: "2rem" }}>
      <button className="cyber-btn" style={{ background: "rgba(255, 255, 255, 0.05)", border: "1px solid rgba(255,255,255,0.2)" }} onClick={downloadJson}>
        <Download size={16} />
        <span>EXPORT JSON</span>
      </button>

      <button className="cyber-btn" style={{ background: "rgba(0, 243, 255, 0.1)", border: "1px solid var(--neon-cyan)", color: "var(--neon-cyan)" }} onClick={copySummaryText}>
        {copied ? <Check size={16} color="var(--neon-emerald)" /> : <Share2 size={16} />}
        <span>{copied ? "SUMMARY COPIED!" : "COPY INTEL SUMMARY"}</span>
      </button>

      <button className="cyber-btn" onClick={onRescan}>
        <RefreshCw size={16} />
        <span>RE-SCAN DOMAIN</span>
      </button>
    </div>
  );
};
